import { Donut, type DonutSeg } from '../common/Donut';
import { fmtEur, fmtEurShort } from './financesData';

// The revenue-source donut — the generic common/Donut wired with euro
// formatters. Kept as a named wrapper so the Finances call sites (and their
// segment colours) read in euro terms; the chart itself is the shared one.
export type { DonutSeg };

export function FinancesDonut({ title, segments }: { title: string; segments: DonutSeg[] }) {
  return <Donut title={title} segments={segments} format={fmtEur} formatShort={fmtEurShort} />;
}
